import { ComponentPropsWithoutRef } from 'react'

import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

import { isRichText } from '@/lib/contentful/utils'

import { Accordions } from '@/components/Accordions'
import { ContentfulRichText } from '@/components/Contentful/common/ContentfulRichText'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Article.hooks'

export function ArticleFAQAccordions(
	props: Omit<ComponentPropsWithoutRef<typeof Accordions>, 'accordions'>
) {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={props.className}>{entry.error}</Warning>
	}

	return (
		<Accordions
			{...props}
			dataTestId="article-faq-accordion"
			accordions={(entry.data.faqsCollection?.items ?? []).map((item) => ({
				title: item?.question ?? '',
				children: item?.answer && <ContentfulRichText field={{ data: item?.answer }} />,
				answer:
					isRichText(item?.answer) && item?.answer.json
						? documentToPlainTextString(item?.answer.json)
						: ''
			}))}
		/>
	)
}
